import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgbAlertModule } from '@ng-bootstrap/ng-bootstrap';
import { Announcement, CorporateActionType } from '@zero/shared/util-models';
import { BezugsrechtAnnouncementListItemKapComponent } from './announcement-list-item-kap/announcement-list-item-kap.component';
import { BezugsrechtAnnouncementListItemTeilrechtComponent } from './announcement-list-item-teilrecht/announcement-list-item-teilrecht.component';
import { BezugsrechtAnnouncementListItemWahldividendeComponent } from './announcement-list-item-wahldividende/announcement-list-item-wahldividende.component';

@Component({
  imports: [
    NgbAlertModule,
    BezugsrechtAnnouncementListItemKapComponent,
    BezugsrechtAnnouncementListItemTeilrechtComponent,
    BezugsrechtAnnouncementListItemWahldividendeComponent,
  ],
  selector: 'bezugsrecht-announcement-list-item',
  templateUrl: './announcement-list-item.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BezugsrechtAnnouncementListItemComponent {
  @Input() public announcement?: Announcement;
  public CorporateActionType = CorporateActionType;
}
